import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../../../../components/form/FormInput';

export const CommonContactFields = ({ register, errors, initialValues, layout = 'grid', validations }) => {
  const { t } = useTranslation();

  const fields = [
    { key: 'name', label: 'RESPONSIBILITY', type: 'text', required: true },
    { key: 'phone', label: 'CONTACT_MOBILE', type: 'text', required: true },
    { key: 'team', label: 'DEPARTMENT', type: 'text', required: true },
    { key: 'email', label: 'RESPONSIBILITY_EMAIL', type: 'email', required: true },
  ];

  if (layout === 'grid') {
    return (
      <div className='grid grid-cols-2 gap-8'>
        <div className='flex flex-col gap-8'>
          {fields.slice(0, 2).map((field) => (
            <FormInput
              key={field.key}
              label={t(field.label)}
              required={field.required}
              type={field.type}
              {...register(field.key, validations?.[field.key] || { required: field.required })}
              error={errors[field.key]}
              defaultValue={initialValues?.[field.key]}
            />
          ))}
        </div>
        <div className='flex flex-col gap-8'>
          {fields.slice(2, 4).map((field) => (
            <FormInput
              key={field.key}
              label={t(field.label)}
              required={field.required}
              type={field.type}
              {...register(field.key, validations?.[field.key] || { required: field.required })}
              error={errors[field.key]}
              defaultValue={initialValues?.[field.key]}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-4'>
      {fields.map((field) => (
        <FormInput
          key={field.key}
          label={t(field.label)}
          required={field.required}
          type={field.type}
          {...register(field.key, validations?.[field.key] || { required: field.required })}
          error={errors[field.key]}
          defaultValue={initialValues?.[field.key]}
          style={{ maxWidth: '420px' }}
        />
      ))}
    </div>
  );
};
